import { SVGProps } from 'react';

export function CompanyIcon(props: SVGProps<SVGSVGElement>) {
  const { fill } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M4 14C4 13.6545 4 7.80893 4 4.498C4 4.22186 4.22386 4 4.5 4H11.5C11.7761 4 12 4.22386 12 4.5V14" stroke={fill} />
      <path d="M5 4C5 3.94341 5 3.14936 5 2.49994C5 2.2238 5.22386 2 5.5 2H10.5C10.7761 2 11 2.22386 11 2.5V4" stroke={fill} />
      <path d="M7 14C7 13.9077 7 12.5069 7 11.4999C7 11.2237 7.22386 11 7.5 11H8.5C8.77614 11 9 11.2239 9 11.5V14" stroke={fill} />
      <path d="M2 14H14" stroke={fill} strokeLinecap="round" />
      <path d="M6 7H7" stroke={fill} strokeLinecap="round" />
      <path d="M9 7H10" stroke={fill} strokeLinecap="round" />
      <path d="M6 9H7" stroke={fill} strokeLinecap="round" />
      <path d="M9 9H10" stroke={fill} strokeLinecap="round" />
    </svg>
  );
}
